import apiOffice from "../axios/apiOffice";

export async function getNotificaciones() {
  const token = localStorage.getItem("token");

  if (!token) {
    return { notificaciones: [], notRead: 0 };
  }

  try {
    const response = await apiOffice.get("/communications/muni-communications");
    const comunicaciones = response.data.Communications;

    if (!Array.isArray(comunicaciones)) {
      return { notificaciones: [], notRead: 0 };
    }

    const notificaciones = comunicaciones;
    const noLeidas = notificaciones.filter((n) => !n.read);

    return {
      notificaciones,
      notRead: noLeidas.length,
    };
  } catch (error) {
    console.error("Error al obtener notificaciones:", error.response || error);

    return { notificaciones: [], notRead: 0 };
  }
}

export async function marcarComoLeida(id) {
  try {
    await apiOffice.patch(`/communications/${id}/mark-as-read`);
    return true;
  } catch (error) {
    console.error("Error al marcar como leída:", error.response || error);
    return false;
  }
}
